import React from 'react';
import Icon from '@/public/icons/analyzing-loader.svg';

// Types
interface IProps {}

export const LoaderScreen: React.FC<IProps> = () => {
	return (
		<>
			{styles}
			<section className='dummy'>
				<div className='dummy__loader'>
					<Icon className='dummy__icon' />
				</div>
			</section>
		</>
	);
};

const styles = (
	<style>
		{`
					.dummy {
						position: fixed;
						top: 0;
						left: 0;
						width: 100%;
						height: 100%;
						display: flex;
						justify-content: center;
						align-items: center;
						background-color: #fff;
						z-index: 99999;
					}
					.dummy__loader {
						position: relative;
						display: flex;
						justify-content: center;
						align-items: center;
						width: 50px;
						height: 50px;
						margin: 0 auto;
					}
					.dummy__icon {
						display: block;
						margin: 0 auto;
						width: 100%;
						height: 100%;
						max-width: 100%;
						fill: #40BCA3;
						animation: dummy-rotate 1s linear infinite;
					}
					@keyframes dummy-rotate {
						to {
							transform: rotate(360deg);
						}
					}
				`}
	</style>
);
